import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";

import moment from "moment";

var CRMActions = require("lib/actions/CRMActions");
var CRMSelectors = require("lib/selectors/CRMSelectors");

var AgentTaskForm = require("components/appdev/crm/AgentTaskForm");
var DropDownOptions = require("components/utility/DropDownOptions");
var AccountPlans = require("lib/account/AccountPlans");

var Glyphicon = require("components/utility/icons/Glyphicon");
var LoadingButton = require("components/utility/LoadingButton");

require("appdev/crm/new_quotes_page.scss");

@connect(
	(state, props) => {
		var dealID = $wr.getURLParameterByName("deal_id");

		if (dealID) {
			var deal = CRMSelectors.deal({ state, id: $wr.getURLParameterByName("deal_id") });
		}

		var loading = CRMSelectors.isLoadingEstimates({ state, key: "create" }) ||
			CRMSelectors.isLoadingDeals({ state, key: dealID })

		return {
			deal, loading
		}

	},
	(dispatch, props) => ({
		populateData: () => {
			var dealID = $wr.getURLParameterByName("deal_id");
			if (dealID) {
				return dispatch(CRMActions.fetchDeal({
					id: dealID, embeds: ["deal.org", "deal.contact"]
				}))
			} else {
				return Promise.resolve();
			}
		},
		createEstimates: (quotes, customer, dealID) => {
			return dispatch(CRMActions.createEstimates({
				estimates: quotes, customer, query: { deal_id: dealID }
			}))
		},
		updateDeal: (dealID, update, tasks) => {
			return dispatch(CRMActions.updateDeal({
				id: dealID, update, nextTasks: tasks,
				embeds: ["deal.org"]
			}))
		}
	})
)
@providePopulateData({ waitForLoad: true })
class NewQuotesPage extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		this.state = this.getInitialState(props);
	}

	getInitialState(props) {
		props = props || this.props;
		return {
			newQuoteCount: 1, primaryQuoteIndex: 0,
			quotePlanTypes: {}, quoteClassCounts: {}, quoteTeacherCounts: {},
			quoteRLDPresence: {}, quoteDiscounts: {}, quoteDiscountReasons: {},

			task: {
				active: true,
				date: moment().add(4, "days").format("YYYY-MM-DD"),
				text: "Quote FU 1",
				agentEmail: (props.deal.owner || {}).email
			}
		}; 
	}

	increaseNewQuoteCount(e) {
		$wr.nope(e);
		this.setState({ newQuoteCount: this.state.newQuoteCount + 1 });
	}

	decreaseNewQuoteCount(e) {
		$wr.nope(e);
		this.setState({ newQuoteCount: this.state.newQuoteCount - 1 });
	}

	updateQuoteField(fieldKey, index, value) {
		var updated = _.extend({}, this.state[fieldKey], { [index]: value });
		var stateUpdate = { [fieldKey]: updated };

		if (fieldKey === "quotePlanTypes" && AccountPlans.fixedPrice(value) === 0) {
			stateUpdate.quoteTeacherCounts = _.extend(
				{}, this.state.quoteTeacherCounts, { [index]: undefined }
			);
		}

		this.setState(stateUpdate);
	}

	updateTask(key, value) {
		var task = _.extend({}, this.state.task, { [key]: value });
		this.setState({ task })
	}

	createQuotes(goToAccept) {
		var quotes = [];

		var customer = {};
		var deal = this.props.deal;
		if (!deal) {
			window.wrNotifications.triggerDropDownNotification({
				title: "No Deal!", text: "Without a deal, this customer will not have a name.", 
				icon: "exclamation-sign", type: "error" });
			return;
		}
		if (deal.org) {
			var org = deal.org;
			customer.name = org.name;
			
			if (org.custom_fields["Canonical School ID"]) {
				customer.title = "CSID";
				customer.given_name = org.custom_fields["Canonical School ID"];

			} else if (org.custom_fields["Canonical District ID"]) {
				customer.title = "CDID";
				customer.given_name = org.custom_fields["Canonical District ID"];
			}

		} else {
			customer.name = deal.name;
		}

		if (deal && deal.contact) {
			var contact = deal.contact;
			customer.middle_name = contact.first_name;
			customer.family_name = contact.last_name;
			customer.email = contact.email;
		}

		var missingClassCount = false;
		var primaryValue;

		_.times(this.state.newQuoteCount, (index) => {
			var quote = {}

			var planType = this.state.quotePlanTypes[index] || AccountPlans.PAID_PLANS[0];

			if (this.state.quoteClassCounts[index]) {
				var classCount = parseInt(this.state.quoteClassCounts[index]);
			} else {
				missingClassCount = true;
			}

			if (this.state.quoteTeacherCounts[index]) {
				var teacherCount = parseInt(this.state.quoteTeacherCounts[index]);
			}

			var withRLDs = !!this.state.quoteRLDPresence[index];

			if (this.state.quoteDiscounts[index]) {
				var discount = parseFloat(this.state.quoteDiscounts[index]) * 100;
				var discountReason = this.state.quoteDiscountReasons[index];
			}

			if (classCount && teacherCount) {

				quote.items = AccountPlans.itemizedQuote({
					plan: planType,
					studentListCount: classCount,
					teacherCount: teacherCount, 
					withRLDs, discount, discountReason
				});

			} else if (classCount) {
				quote.items = AccountPlans.itemizedQuote({
					plan: planType,
					studentListCount: classCount,
					teacherCount: 0, 
					withRLDs, discount, discountReason
				});
			}

			quotes.push(quote);

			if ((this.state.primaryQuoteIndex == index) && quote.items) {
				primaryValue = AccountPlans.tieredPrice(
					planType, classCount, teacherCount, discount);
			}
		})

		if (missingClassCount) {
			window.wrNotifications.triggerDropDownNotification({
				title: "Missing Info!", text: "Quotes are missing class counts.", 
				icon: "exclamation-sign", type: "error" });
			return;
		}

		var dealUpdate = {
			value: primaryValue
		}

		this.props.createEstimates(quotes, customer, deal.id).then((response) => {
			if (this.state.task && this.state.task.active) {
				var tasks = [{
					due_date: this.state.task.date,
					content: this.state.task.text,
					owner_email: this.state.task.agentEmail
				}]
			}

			this.props.updateDeal(deal.id, dealUpdate, tasks).then((response) => {
				var updatedDeal = (response.deals || [])[0];
				if (updatedDeal.org) {
					var driveID = updatedDeal.org.custom_fields["Drive ID"]
					window.open("https://drive.google.com/drive/u/0/folders/" + driveID);
				}

				if (goToAccept) {
					$wr.redirect("/received?deal_id=" + deal.id);
				} else {
					this.setState(this.getInitialState());
				}
			});
		})
	}

	renderNewQuotesForm() {
		var rows = [];
		_.times(this.state.newQuoteCount, (index) => {
			var starIcon = index == this.state.primaryQuoteIndex ? "star" : "star-empty";

			var quotePlan = this.state.quotePlanTypes[index] || AccountPlans.PAID_PLANS[0];

			if (this.state.quoteDiscounts[index]) {
				var discount = parseFloat(this.state.quoteDiscounts[index]) * 100;
			}

			if (this.state.quoteClassCounts[index]) {
				if (this.state.quoteTeacherCounts[index]) {
					var teacherCount = this.state.quoteTeacherCounts[index];
				} else {
					var teacherCount = 0;
				}

				var planPrice = AccountPlans.tieredPrice({
					plan: quotePlan,
					studentListCount: parseInt(this.state.quoteClassCounts[index]),
					teacherCount: teacherCount,
					withRLDs: this.state.quoteRLDPresence[index],
					discount: discount
				});
			}

			rows.push(
				<tr key={ index }>
					<td>
						<button className="btn btn-link primaryStar"
							onClick={ (e) => this.setState({ primaryQuoteIndex: index }) }>
							<Glyphicon icon={ starIcon } />
						</button>
					</td>
					<td>
						<select value={ quotePlan } className="form-control"
							onChange={ (e) => this.updateQuoteField("quotePlanTypes", index, e.target.value) }>

							{ DropDownOptions.Select.PaidPlanOptions() }
							<option value={ AccountPlans.RLD_ONLY_ANNUAL }>
								{ AccountPlans.name(AccountPlans.RLD_ONLY_ANNUAL) }
							</option>
							<option value={ AccountPlans.RLD_ONLY_SEMESTER }>
								{ AccountPlans.name(AccountPlans.RLD_ONLY_SEMESTER) }
							</option>
						</select>
					</td>
					<td>
						<input type="number" className="form-control"
							disabled={ AccountPlans.fixedPrice(quotePlan) === 0 }
							value={ this.state.quoteTeacherCounts[index] || "" }
							onChange={ (e) => this.updateQuoteField("quoteTeacherCounts", index, e.target.value) } />
					</td>
					<td>
						<input type="number" className="form-control"
							value={ this.state.quoteClassCounts[index] || "" }
							onChange={ (e) => this.updateQuoteField("quoteClassCounts", index, e.target.value) } />
					</td>
					<td>
						<input type="checkbox"
							checked={ !!this.state.quoteRLDPresence[index] }
							onChange={ (e) => this.updateQuoteField("quoteRLDPresence", index, !this.state.quoteRLDPresence[index]) } />
					</td>
					<td>
						<input type="number" className="form-control"
							value={ this.state.quoteDiscounts[index] || "" }
							onChange={ (e) => this.updateQuoteField("quoteDiscounts", index, e.target.value) } />
					</td>
					<td>
						<input type="text" className="form-control"
							value={ this.state.quoteDiscountReasons[index] || "" }
							onChange={ (e) => this.updateQuoteField("quoteDiscountReasons", index, e.target.value) } />
					</td>
					<td>
						{ $wr.centsToDollars(planPrice) }
					</td>
				</tr>
			);
		})

		if (this.state.newQuoteCount > 1) {
			var removeLine = (
				<a href="#" className="removeLineLink" onClick={ this.decreaseNewQuoteCount }>
					<Glyphicon icon="minus" /> Remove Line
				</a>
			);
		}

		if (this.props.deal) {
			var buttonSection = (
				<div className="actions">
					<LoadingButton loading={ this.props.loading } text="Create Quotes"
						className="btn buttonPrimary"
						onClick={ this.createQuotes.bind(this, false) } />
					<LoadingButton loading={ this.props.loading } text="Create Quotes & Accept"
						className="btn buttonDefault"
						onClick={ this.createQuotes.bind(this, true) } />
				</div>
			);
		}

		return (
			<div>
				<table className="table table-bordered quoteTable">
					<tbody>
						<tr>
							<th>Primary?</th>
							<th className="planCol">Plan</th>
							<th>Teacher Count</th>
							<th>Class Count</th>
							<th>RLDs?</th>
							<th>Discount</th>
							<th className="reasonCol">Discount Reason</th>
							<th className="totalCol">Total</th>
						</tr>
						{ rows }
						<tr>
							<td colSpan={ 8 } className="text-center">
								<a href="#" onClick={ this.increaseNewQuoteCount }>
									<Glyphicon icon="plus" /> Add Quote
								</a> { removeLine }
							</td>
						</tr>
					</tbody>
				</table>

				<AgentTaskForm task={ this.state.task } onChange={ this.updateTask } />

				<div className="text-center">
					{ buttonSection }
				</div>
			</div>
		)
	}

	render() {
		if (this.props.deal) {
			var dealName = this.props.deal.name;
			var dealLinkBase = "https://app.futuresimple.com/sales/deals/";
			var dealLink = (
				<a href={ dealLinkBase + this.props.deal.id } target="_blank">
					<Glyphicon icon="link" />
				</a>
			)
		}
		return (
			<div className="newQuotesPage container">
				<div className="headerSection">
					<header className="pageHeader">
						<h1>New Quotes</h1>
					</header>
				</div>

				<p>
					<strong>Deal</strong>: { dealName } { dealLink }
				</p>
				{ this.renderNewQuotesForm() }
			</div>
		);
	}

};

var QUICKBOOKS_REALM_ID = 1024560580;
var QB_BASE_URL = "https://quickbooks.api.intuit.com"
var ESTIMATE_PATH_PREFIX = "/v3/company/" + QUICKBOOKS_REALM_ID + "/estimate/"
var ESTIMATE_PATH_SUFFIX = "/pdf";

NewQuotesPage.WrappedComponent.propTypes = PageStrictPropTypes({
	// Data from @connect
	deal: PropTypes.object,
	loading: PropTypes.bool,

	// Handlers from @connect
	populateData: PropTypes.func.isRequired,
	createEstimates: PropTypes.func.isRequired,
	updateDeal: PropTypes.func.isRequired
});

module.exports = NewQuotesPage;



// WEBPACK FOOTER //
// ./modules/components/appdev/crm/NewQuotesPage.js